/**
 * Input length caps for the vehicle fields that ride the AMS DbSync push.
 *
 * The LOS Color column is nvarchar(25), but the AMS carColor field is VARCHAR2(10) and the AMS
 * payload is silently truncated before posting — so DbSync clients are capped at the AMS length to
 * keep the two systems from holding different values. Clients with no DbSync URL keep the full 25.
 *
 * The tag number is CAR_TAG_NO VARCHAR2(12) in AMS and nvarchar(12) in the LOS, so 12 for everyone.
 * These match the server-side validation in VehicleService.CreateVehicleAsync.
 */
const COLOR_MAX_LENGTH_FOR_DB_SYNC_CLIENTS = 10;
const COLOR_MAX_LENGTH = 25;
export const CAR_TAG_NO_MAX_LENGTH = 12;

export const getColorMaxLength = (clientHasDbSyncUrl?: boolean): number =>
  clientHasDbSyncUrl ? COLOR_MAX_LENGTH_FOR_DB_SYNC_CLIENTS : COLOR_MAX_LENGTH;
